import {useForm} from "@formspree/react";
import {Link} from "gatsby";
import FormSpreeForm from "../formSpreeForm/formSpreeForm";
import React from "react";

export default function SubmitWrapper({state, handleInput,test}) {
    const [formState, handleSubmit] = useForm("xbjqwkll", {debug: true})
    if (formState.succeeded || test) {
        return (
            <div
                className={"after-submit"}
                style={{
                    display:"flex",
                    flexDirection:"column",
                    alignItems:"center",
                }}
            >

                <h2
                    className={"primary"}
                    style={{
                        fontSize: "35px",
                        letterSpacing: "7px",
                        textTransform: "uppercase",
                        fontWeight: "900",
                        fontFamily: "mr-eaves-sans"
                    }}
                >Thank You!</h2>
                <p
                    style={{
                        fontSize: "18px",
                        lineHeight: "23px",
                        textAlign: "center",
                        color: "var(--secondary)"
                    }}
                >
                    You can expect a response from me within one business
                    <br/>
                    day!
                    I can't wait to hear about your project!
                </p>
                <Link to={"/"} style={{
                    backgroundColor: "var(--primary)",
                    color: "var(--white)",
                    fontFamily: "mr-eaves-sans",
                    width: "20%",
                    height: "2em",
                    fontSize: "18px",
                    padding: "2% 0 0 0",
                    fontWeight: 600,
                    letterSpacing: "2.2px",
                    textDecoration: "none",
                    borderRadius: "7px",
                    textAlign:"center"
                }}>HOME</Link>
            </div>
        )
    }
    return <aside>
        <h2 className={"primary"}>let's do this</h2>
        <hr className={""}/>
        <p>
            If you’ve made it this far,
            you’re probably ready to take the next step.
            Drop me a message and let’s get started!
            I can’t wait to see what we create together.
        </p>
        <FormSpreeForm
            formState={formState}
            handleSubmit={handleSubmit}
            handleInput={handleInput}
            valid={state.isValid}
            update={state.needsUpdate}
        />
    </aside>
}